import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** SRCZ（窮境のマイペース） */
const srczContent: DiagnosisResultContent = {
  code: 'SRCZ',
  name: '窮境のマイペース',
  catchphrase: '「旅行疲れ」を知らない仙人。時間という概念から解放された',
  rarity: 4,
  style:
    '「自分のリズムこそ正義」を極めたマイペースの達人。計画にも他人のペースにも縛られず、心地よい場所で好きなだけ過ごす。急ぐことも欲張ることもなく、窮屈さから解放された状態で旅する。周囲から見ると「何してるの？」と思われても、本人は至福。時間の概念から自由になった、旅の仙人タイプ。',
  strengths: [
    { lead: '自分軸が揺るがない', text: '周囲に流されず、本当に心地よい過ごし方を選べる。' },
    { lead: '旅行疲れゼロ', text: '無理しないため、帰ってもすっきりしている。' },
    { lead: '深い満足感', text: '焦らない旅は、記憶にゆっくりと残る。' },
  ],
  weaknesses: [
    { lead: '協調が難しい', text: 'ペースを譲りにくく、グループ旅では摩擦が出やすい。' },
    { lead: '機会損失', text: '気が乗らないと動かず、体験を逃すことも。' },
    { lead: '外から見えると「何もしてない」', text: '同行者が「もったいない」と感じることがある。' },
  ],
  aaru: [
    { icon: 'msg', text: '「自分は自分のペースで」が口癖' },
    { icon: 'coffee', text: '気が済むまでその場に居る' },
    { icon: 'camera', text: '人混みは避けて静かな所へ' },
    { icon: 'coffee', text: '予定変更にも動じない' },
  ],
  manual: {
    good: 'ペースを尊重する／別行動を許容する',
    ng: '「みんなに合わせて」と同調を強いる',
    tips: '別行動と合流ポイントを決めると気持ちよく旅できる',
  },
  compatibility: {
    good: 'SRCE（自由放浪）／SACZ（脱力系）',
    conflict: 'PACE（完璧弾丸）／PALE（食い倒れ）',
    tips: '自由時間をしっかり確保すれば協調もしやすい',
  },
  destinations: {
    domestic: '小さな温泉宿（静かに過ごす）／離島（自分時間を満喫）',
    overseas: 'チェンマイ（のんびり長期滞在）／台湾の地方（静かな自由旅）',
  },
};

export const srczDiagnosisResult = buildDiagnosisResult(srczContent);
